<rt-group>
  <rt-button
    #followDropdownTrigger="rtOverlayOrigin"
    [loading]="loading()"
    [rtTooltip]="tooltipText"
    [rtTooltipPosition]="'below'"
    (click)="followed() ? unfollowAction() : followAction()"
    rt-overlay-origin
    variant="plain"
    [class.followed]="followed()"
  >
    @if (!followed()) {
      <rt-icon name="bookmark-border" />
    }
    @if (followed()) {
      <rt-icon name="bookmark" colorToken="colorIconSuccessDefault" />
    }
    <span [class.responsive]="responsive()" class="status">{{ statusText }}</span>
    @if (users.length) {
      <rt-total-followers
        [users]="users"
        (click)="followed() ? unfollowAction() : followAction(); $event.stopImmediatePropagation()"
        (mouseleave)="showTooltip(tooltip)"
        (mouseenter)="hideTooltip(tooltip)"
      />
    }
  </rt-button>
</rt-group>
